<template>
   <div class="d-flex align-items-center">
      <img
         v-show="isImageDoneLoading"
         :src="image"
         :style="cssVars"
         :class="[{ 'choice-image my-2': !card }, { 'w-100': card }]"
         @load="doneLoading()"
      />
      <div
         v-if="choice && choice.file_id && !isImageDoneLoading"
         v-show="!isImageDoneLoading"
         class="d-flex justify-content-center"
         :class="{ 'choice-image-large': card }"
         :style="cssVars"
      >
         <div class="choice-loading d-flex flex-column justify-content-center">
            <LoadingAnimation :color="'Grey'"></LoadingAnimation>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
   components: {
      LoadingAnimation: () => import('@/core/components/LoadingAnimation'),
   },

   props: {
      maxHeight: Number,
      isChoice: Boolean,
      choice: Object,
      card: Boolean,
      index: Number,
      parentId: { required: false, type: String },
   },

   data() {
      return {
         isImageDoneLoading: false,
         image: null,
         availableWidth: 0,
      };
   },

   created() {
      this.getImage();
   },

   updated() {
      let container = document.getElementById(this.parentId);
      this.availableWidth = container ? container.getBoundingClientRect().width * 0.9 : 0;
   },

   computed: {
      ...mapGetters(['choiceImages']),

      cssVars() {
         const calcHeight = this.choice && this.choice.file ? 644 / this.choice.file.width : null;
         return {
            '--height':
               this.choice && this.choice.file
                  ? this.parentId
                     ? this.getMediaSize(this.choice.file.width, this.choice.file.height).height + 'px'
                     : this.choice.file.height * calcHeight + 'px'
                  : '65px',
            '--width': this.choice && this.choice.file ? this.choice.file.width + 'px' : '65px',
            '--max-height': this.maxHeight ? this.maxHeight + 'px' : 644 * calcHeight + 'px',
            '--backgroundColor': this.isChoice ? 'white' : 'transparent',
         };
      },
   },

   methods: {
      getMediaSize(iw, ih) {
         const MAX_WIDTH = this.availableWidth;
         const MAX_HEIGHT = this.maxHeight;

         let widthPercent = MAX_WIDTH / iw;
         let heightPercent = MAX_HEIGHT / ih;
         let smallestPercent = Math.min(widthPercent, heightPercent);

         return {
            width: iw * smallestPercent,
            height: ih * smallestPercent,
         };
      },
      getImage() {
         if (this.choice && this.choice.file_id) {
            let image = this.choiceImages.find(
               (image) => image.key == `S${this.$route.query.step}M${this.$route.query.module}C${this.index}`
            );
            this.image = image ? image.data : null;
            if (!this.image) {
               this.$store.dispatch('getFileById', this.choice.file_id).then((response) => {
                  this.image = response;
               });
            }
         }
      },

      doneLoading() {
         this.$emit('doneLoading');
         this.isImageDoneLoading = true;
      },
   },
};
</script>

<style lang="scss" scoped>
.choice {
   &-loading {
      height: var(--height);
      width: var(--width);
      max-width: 50%;
      max-height: var(--max-height) !important;
   }

   &-image {
      background-color: var(--backgroundColor);
      max-height: var(--max-height);
      max-width: 90%;
      object-fit: contain;
      object-position: center;
      &-large {
         min-height: 300px;
         min-width: 300px;
      }
   }
}
</style>
